import { gsap, ScrollTrigger } from '../global/gsap';

const initFeaturedFilm = (section) => {
    const media = section.querySelector('.js-featured-film-media');

    if (!media) return;

    const toggleMedia = (position) => {
        media.style.position = position;
    };

    const mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', () => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                end: 'bottom bottom',
                onLeave: () => toggleMedia('absolute'),
                onEnterBack: () => toggleMedia('fixed')
            }
        });
    });
};

export default initFeaturedFilm;
